import api from "../../../../util/Api";
import { pageNumberValue, pageSizeValue } from "../../../../util/StaticData/SelectStaticData";
import {
	DELETE_FAILED_USERS_FAILURE,
	DELETE_FAILED_USERS_REQUEST,
	DELETE_FAILED_USERS_SUCCESS,
	DELETE_PL9_HARDWARE_FAILURE,
	DELETE_PL9_HARDWARE_REQUEST,
	DELETE_PL9_HARDWARE_SUCCESS,
	GET_FAILED_USERS_FAILURE,
	GET_FAILED_USERS_LENGTH_FAILURE,
	GET_FAILED_USERS_LENGTH_REQUEST,
	GET_FAILED_USERS_LENGTH_SUCCESS,
	GET_FAILED_USERS_REQUEST,
	GET_FAILED_USERS_SUCCESS,
	PL9_HARDWARE_FAILURE,
	PL9_HARDWARE_REQUEST,
	PL9_HARDWARE_SUCCESS,
} from "./pl9HardwareConstant";

export const getPl9HardwareCommandsSetting = (
	pageNumber = 1,
	pageSize = 20,
	deviceIds = []
) => {
	return async (dispatch) => {
		try {
			dispatch({ type: PL9_HARDWARE_REQUEST });

			const { data } = await api.post("Setting/PL9HardwareCommads", {
				pageNumber,
				pageSize,
				deviceIds,
			});
			return dispatch({
				type: PL9_HARDWARE_SUCCESS,
				payload: data,
			});
		} catch (error) {
			dispatch({
				type: PL9_HARDWARE_FAILURE,
				payload: error
					? {
							message: error.statusText,
							status: error.status,
							error: error,
					  }
					: "",
			});
		}
	};
};

export const deletePL9HardwareCommands = (pl9HardwareCommandsIds) => {
	return async (dispatch) => {
		try {
			dispatch({ type: DELETE_PL9_HARDWARE_REQUEST });

			const response = await api.delete(
				"Setting/DeletePL9HardwareCommad",
				{ data: { pl9HardwareCommandsIds } }
			);
			return dispatch({
				type: DELETE_PL9_HARDWARE_SUCCESS,
				response,
			});
		} catch (error) {
			dispatch({
				type: DELETE_PL9_HARDWARE_FAILURE,
				payload: error
					? {
							message: error.statusText,
							status: error.status,
							error: error,
					  }
					: "",
			});
		}
	};
};

export const getFailedUsers =
	(pageNumber = pageNumberValue,
		pageSize = pageSizeValue) =>
	async (dispatch) => {
		try {
			dispatch({ type: GET_FAILED_USERS_REQUEST });
			const { data } = await api.post("Setting/GetFailedUsers", {
				pageSize,
				pageNumber,
			});

			return dispatch({ type: GET_FAILED_USERS_SUCCESS, payload: data });
		} catch (error) {
			dispatch({
				type: GET_FAILED_USERS_FAILURE,
				payload: error
					? {
							message: error.statusText,
							status: error.status,
							error: error,
					  }
					: "",
			});
		}
	};

export const getFailedUsersLength = () => async (dispatch) => {
	try {
		dispatch({ type: GET_FAILED_USERS_LENGTH_REQUEST });
		const { data } = await api.get("Setting/GetFailedUsersLength");
		return dispatch({ type: GET_FAILED_USERS_LENGTH_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: GET_FAILED_USERS_LENGTH_FAILURE,
			payload: error
				? {
						message: error.statusText,
						status: error.status,
						error: error,
				  }
				: "",
		});
	}
};
export const deleteFailedRuleUser = (failedUsers) => async (dispatch) => {
	try {
		dispatch({ type: DELETE_FAILED_USERS_REQUEST });

		const response = await api.delete("Setting/DeleteFailedUsers", {
			data: {
				failedUsers
			,
		}});
		return dispatch({ type: DELETE_FAILED_USERS_SUCCESS, response });
	} catch (error) {

		dispatch({
			type: DELETE_FAILED_USERS_FAILURE,
			payload: error
				? {
						message: error.statusText,
						status: error.status,
						error: error,
				  }
				: "",
		});
	}
};
